import React, { FC, useMemo } from 'react';
import NotificationActionWrapper from './NotificationActionWrapper';
import { getNotificationLabelFromDetails } from '../../utils/NotificationUtils';
import SeparatorWithText from '../common/SeperatorWithText';
import ManageAllNotificationPreference from './ManageAllNotificationPreference';
import { Button, Form, Switch } from 'antd';
import { useForm } from 'antd/lib/form/Form';

const FORM_ID = 'notification-preferences-form';

interface NotificationPreferenceCardProps {
	notificationDetails: any;
	onUpdatePreference: (v: any) => void;
	onCancel: () => void;
	updating: boolean;
	existingConfig: any;
}

const getValueWithDefaultIfUndefined = (obj, key, defaultValue) =>
	obj && obj[key] !== undefined ? obj[key] : defaultValue;

const NotificationPreferenceCard: FC<NotificationPreferenceCardProps> = ({
	notificationDetails,
	onUpdatePreference,
	onCancel,
	updating,
	existingConfig,
}): React.ReactElement => {
	const [form] = useForm();

	const initialValues = useMemo(
		() => ({
			email: getValueWithDefaultIfUndefined(existingConfig, 'email', true),
			inApp: getValueWithDefaultIfUndefined(existingConfig, 'inApp', true),
		}),
		[existingConfig]
	);

	return (
		<NotificationActionWrapper>
			<div className="h2medium">{getNotificationLabelFromDetails(notificationDetails)}</div>
			<SeparatorWithText />
			<Form
				form={form}
				id={FORM_ID}
				style={{ textAlign: 'right', width: '100%', paddingLeft: 4, paddingRight: 4 }}
				layout="horizontal"
				labelCol={{ span: 12 }}
				wrapperCol={{ span: 12 }}
				labelAlign="left"
				requiredMark={false}
				onFinish={onUpdatePreference}
				initialValues={initialValues}
			>
				<Form.Item
					style={{ marginBottom: 16 }}
					name="email"
					label="Email Notifications"
					valuePropName="checked"
				>
					<Switch />
				</Form.Item>
				<Form.Item
					style={{ marginBottom: 32 }}
					name="inApp"
					label="Mobile Push Notifications"
					valuePropName="checked"
				>
					<Switch />
				</Form.Item>
				<div className="flex w-full flex-col justify-center gap-4">
					<Button
						type="primary"
						size="large"
						key="submit"
						htmlType="submit"
						form={FORM_ID}
						loading={updating}
					>
						Update Preference
					</Button>
					<Button type="primary" ghost size="large" onClick={onCancel}>
						Cancel
					</Button>
				</div>
			</Form>
			<SeparatorWithText className="mt-4" text="OR" />
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default NotificationPreferenceCard;
